import { useEffect, useState } from "react";

export const useDimensions = () => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    getDimensions();
  }, [window.innerWidth, window.innerHeight]);
  const getDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  return { width, height };
};
